export default {
  angle: 0,
};
